import * as React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { ShopsView, ShopLocationView } from '.';

export const ShopSwitch: React.FC<RouteComponentProps<{ id?: string }>> = ({
  match: { url, path },
}) => (
  <React.Fragment>
    <BreadcrumbsItem to={url}>Shops</BreadcrumbsItem>

    <Switch>
      <Route exact path={path}>
        <ShopsView />
      </Route>

      <Route path={`${path}/:id([0-9]+)/locations`}>
        <ShopLocationView />
      </Route>

      <Route>
        <Redirect to={path} />
      </Route>
    </Switch>
  </React.Fragment>
);
